import { render, staticRenderFns } from "./BaseReceiptError.vue?vue&type=template&id=091b97be&scoped=true&"
import script from "./BaseReceiptError.vue?vue&type=script&lang=js&"
export * from "./BaseReceiptError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091b97be",
  null
  
)

export default component.exports